import React, { useState } from "react";
import { Box, Button, Modal, TextField } from "@mui/material";
import { handleClick } from "./handleClick";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function ModalPoints({ id, openModal, setOpenModal, type, handleUpdatePoints}) {
  const [points, setPoints] = useState(0);
  const [comment, setComment] = useState("");
  const [errorPoints, setErrorPoints] = useState("");
  const [errorComment, setErrorComment] = useState("");

  const handleClose = () => {
    setOpenModal(false);
    setErrorPoints("");
    setErrorComment("");
  };

  const handleSubmit = () => {
    if (!comment.trim()) setErrorComment("Комментарий не может быть пустым.");
    if (points <= 0) setErrorPoints("Количество баллов должно быть больше нуля.");
    if (!Number.isInteger(points)) setErrorPoints("Число баллов должно быть целым");
    if (comment.trim() && points > 0) {
      handleClick(id, points, type, comment, handleClose, handleUpdatePoints);
    }
  };

  return (
    <Modal open={openModal} onClose={handleClose}>
      <Box sx={style}>
        <Box my={4} display="flex" flexDirection="column" gap={4}>
          <TextField
            label="Укажите количество баллов"
            type="number"
            value={points}
            onChange={(e) => setPoints(parseInt(e.target.value))}
            error={!!errorPoints}
            helperText={errorPoints}
          />
          <TextField
            label="Комментарий"
            multiline
            maxRows={4}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            error={!!errorComment}
            helperText={errorComment}
          />
          <Button onClick={handleSubmit}>
            {type === "addPoints" ? "Начислить" : "Списать"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}